import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider as ReduxProvider } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import { getLogger, initializeLogger, inIframe, observerResizeIframe } from '@chilecompra/react-kit'
import Package from '../package.json'
import { REACT_APP_ENVIRONMENT, REACT_APP_MERCADO_PUBLICO_BASE_URL } from './config/settings/environment'
import initializeAnalytics from './config/settings/analytics'
import storeSingleton from './config/store/store'
import theme from './config/styles/theme'
import Routing from './Routing'
import SnackbarProvider from './containers/SnackbarProvider/SnackbarProvider.container'

initializeAnalytics()
initializeLogger({ env: REACT_APP_ENVIRONMENT === 'prod' ? 'prod' : 'dev' })

const store = storeSingleton()
const logger = getLogger('App')
const container = document.getElementById('__root')
const root = createRoot(container)

logger.info(`React v${React.version}`)
logger.info(`Ficha del Comprador v${Package.version}`)

// This enables communication between react and MP applications to resize the fraDetalle iframe.
if (inIframe()) {
  observerResizeIframe(REACT_APP_MERCADO_PUBLICO_BASE_URL, { childList: true })
}

root.render(
  <StrictMode>
    <ReduxProvider store={store}>
      <ThemeProvider theme={theme}>
        <Routing />
        <SnackbarProvider />
      </ThemeProvider>
    </ReduxProvider>
  </StrictMode>
)
